var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.349,
    height: 15.137,
    viewBox: "0 0 13.349 15.137",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M42.064,37.018a5,5,0,1,1,10.007.063v.494a9.374,9.374,0,0,0,.982,4.736.557.557,0,0,1-.48.839H41.561a.557.557,0,0,1-.479-.839,9.37,9.37,0,0,0,.983-4.736Zm2.773,6.132v.557a2.23,2.23,0,0,0,4.46,0V43.15",
    transform: "translate(-40.393 -31.401)",
    fill: "none",
    stroke: "#3b57a9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.164aa8435c0bea06008199900f4e4573.svg";
export { ForwardRef as ReactComponent };